export const Common = {
  // 提示框
  confirmDialog: (tipData) => {
    tipData.that.$confirm(tipData.tipText, tipData.tipTitle, {
      confirmButtonText: tipData.confirmButtonText || '确定',
      cancelButtonText: tipData.cancelButtonText || '取消',
      type: tipData.type,
      showCancelButton: tipData.showCancelButton
    }).then(() => {
      tipData.callBack ? tipData.callBack() : ''
    }).catch(() => {
      tipData.errorCallBack ? tipData.errorCallBack() : ''
    })
  },
  /**
	 * 正整数
	 * */
  checkRegExpNumber(rule, value, callback) {
    var rxp = /^\+?[1-9][0-9]*$/
    if (!rule.required) {
      if (!value) {
        callback()
      } else if (!rxp.test(value)) {
        return callback(new Error('只支持正整数'))
      }
    }
    if (!value) {
      return callback(new Error('请输入正整数'))
    } else {
      callback()
    }
  },
  getParams: function(str = window.location.href) {
    var params = str.split('?')
    if (params.length < 2) return {}
    var param = params[1].split('&')
    var obj = {}
    for (let i = 0; i < param.length; i++) {
      var paramsA = param[i].split('=')
      var key = paramsA[0]
      var value = paramsA[1]
      obj[key] = value
    }
    return obj
  },
  go: function(module, page, params, blank) {
    var _p = !params || Object.keys(params).length === 0 ? '' : genurl(params)
    var href = '/customer/' + module + '/' + page + '.html'
    if (blank) {
      window.open(href, '_blank')
    } else {
      window.location.href = _p ? href + '?' + _p : href
    }
  },
}
function genurl(param, key, encode) {
  // if (!param || layui.$.isEmptyObject(param)) return ''
  var params = []
  var t = typeof param
  if (t == 'string' || t == 'number' || t == 'boolean') {
    params.push(key + '=' + (encode == null || encode ? encodeURIComponent(param) : param))
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
      params.push(genurl(param[i], k, encode))
    }
  }
  return params.join('&')
}
